export const blackColor = '#000000'
export const whiteColor = '#ffffff'
export const primaryColor = '#9c131c'
export const darkColor = '#670000'
export const lightColor = '#d34b44'


